<!--
  画面名：-
  画面概要：フローダイアグラムを表示する
  備考：
-->
<!--  html部分  -->
<template>
  <div class="flowDiagramWrapper" :class="[{untouchable:isPlan},{operation:isOperation}]">
    <!-- フローダイアグラムについての説明表示要素 -->
    <div class="description">
      <table cellpadding="0" cellspacing="0" border="0">
        <tbody :style="{'transform': 'scale(' + otherExpansion + ')'}">
          <tr class="trGroup0Style">
            <th class="thGroup0Style">
              {{language.LabelLineGroup0}}
              <div class="group0Style"></div>
            </th>
          </tr>
          <tr class="trGroup1Style">
            <th class="thGroup1Style">
              {{language.LabelLineGroup1}}
              <div class="group1Style"></div>
            </th>
          </tr>
          <tr class="trGroup2Style">
            <th class="thGroup2Style">
              {{language.LabelLineGroup2}}
              <div class="group2Style"></div>
            </th>
          </tr>
          <tr class="trGroup3Style">
            <th class="thGroup3Style">
              {{language.LabelLineGroup3}}
              <div class="group3Style"></div>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- フローダイアグラム表示要素 -->
    <div class="flowDiagram" ref="flowDiagram">
      <!-- メッセージ表示領域 -->
      <div v-if="!isPlan && !isOperation">
        <div v-if="!isList" style="color: red;font-size: 13px;padding-bottom: 13px;">
          {{$language.MsgSetManualMessage}}
        </div>
        <div v-else style="color: red;font-size: 13px;padding-bottom: 13px;">
          {{$language.MsgViewManualMessage}}
        </div>
      </div>

      <table cellpadding="0" cellspacing="0" border="0" class="flow-table" ref="flowDiagramTable" :style="{'transform': 'scale(' + flowDiagramScale + ')'}">
        <tbody>
          <tr
            :key="trElement.id"
            v-for="trElement in flowDiagramJsonData"
            :style="trElement.trStyle"
            >
            <td
              :key="tdElement.id"
              v-for="tdElement in trElement.diagramBoxes"
              :style="tdElement.tdStyle"
              :class="{cursorDefault:(isList && !tdElement.tdStyle['background-color'])}"
              class="flow-diagram-attr-text"
              @click="openManual(tdElement.id,tdElement.title)"
            >{{tdElement.title}}<div
                :key="divElement.id"
                v-for="divElement in tdElement.lineGroups"
                :style="divElement">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- フローダイアグラムに入らない作業（一般衛生管理）表示要素 計画書には表示しない -->
    <div v-if="!isSetting" class="generalHygieneManagement">
      <table cellpadding="0" cellspacing="0" border="0">
        <tbody>
          <tr style="width: 100%;margin-top: 17px" :style="{'transform': 'scale(' + otherExpansion + ')'}">
            <th v-if="isList" style="cursor: default">{{$language.LabelGeneralHygiene}}</th>
            <th v-else @click="openManual(0)">
              <span :class="{underline:!isPlan}">{{$language.LabelGeneralHygiene}}</span>
            </th>
          </tr>
          <tr
            :key="generalHygieneManagement.id"
            v-for="generalHygieneManagement in generalHygieneManagementData"
            >
            <td v-if="!isOperation">{{generalHygieneManagement.name}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 登録、差し換え・設定変更ダイアログ -->
    <TemplateFlowDiagramManualDialog
      ref="TemplateFlowDiagramManualDialog"
      :dialogPageTitle="flowDiagramName"
      :isList="isList"
      :isOperation="isOperation"
      :language="language"
      :configCheckList="configCheckList"
      :manuals="manuals"
      @openManual="openManual"
      @saveManuals="saveManuals"
    />
    <SaveDialog
      ref="saveDialog"
      :msg="errorMessage"
      @close="close"
    />
  </div>
</template>
<script>
import TemplateFlowDiagramManualDialog from '@/components/parts/systemConfig/TemplateFlowDiagramManualDialog' // フローダイアグラム用店舗マニュアル一覧
import SaveDialog from '@/components/parts/common/SaveDialog' // 保存完了ダイアログ

export default {
  name: 'FlowDiagram',
  // 子（外部）コンポーネント設定
  components: {
    TemplateFlowDiagramManualDialog,
    SaveDialog
  },
  // 初期値設定
  data () {
    return {
      // 多言語対応
      language: this.$language,
      // 店舗マニュアルID情報
      manualIds: [],
      // セレクトボックス用店舗マニュアル情報格納
      manuals: [],
      // 分類設定 1:店舗マニュアル 2:衛生チェック 3:一般衛生 4:健康チェック
      classification: 0,
      // フローダイアグラムのID 0:一般衛生 -1:追加 それ以外の数値は作業ボックスID
      flowDiagramId: 0,
      // 店舗マニュアルに表示する作業項目名
      flowDiagramName: '',
      // エラーメッセージ
      errorMessage: '',
      // フローダイアグラムのbox内で選択可能な店舗マニュアルを格納する
      flowDaigramSelectManuals: [],
      // 一般衛生のbox内で選択可能な店舗マニュアルを格納する
      hygieneManagementSelectManuals: [],
      // 変更前マニュアルID情報
      oldManuals: [],
      // 種別：追加
      typeAdd: -1,
      // 種別：一般衛生
      typeHygiene: 0,
      // フローダイアの全ての店舗マニュアルのIDを格納した変数
      allSelectedManuals: [],
      // フローダイアの一つのbox内に割り当て済のIDを格納した変数
      assignedManualIdsOfBox: [],
      // APIアクセスカウントを格納
      accessCount: 0,
      // 拡大
      flowDiagramScale: 1,
      // 一般衛生とグループの拡大
      otherExpansion: 1
    }
  },

  // 親コンポーネント（雛形一覧）から値を取得
  props: {
    flowDiagramJsonData: Array,
    generalHygieneManagementData: Array,
    isOperation: { type: Boolean, default: false },
    generalHygieneManagementIds: Array,
    isallocationCancel: { type: Boolean, default: true },
    isList: { type: Boolean, default: false },
    id: Number,
    isPlan: { type: Boolean, default: false },
    isDialog: { type: Boolean, default: false },
    isSetting: { type: Boolean, default: false },
    configCheckList: { type: Object }
  },
  // 画面起動時処理
  mounted () {
    // Auth情報を取得
    let auth = this.$store.getters['auth/getOperationAuth']
    if (auth && auth.language !== 1) {
      // 日本語でない場合は言語をセット
      this.$store.dispatch('language/actionLanguage', auth.language)
      this.language = this.$store.getters['language/getLanguage']
    }

    if (this.$props.isOperation) {
      // windowサイズがリサイズされた時に背景色のheightを再設定
      window.addEventListener('resize', this.setScale)
    }

    // パラメータ初期化
    this.initilize(-1)

    // 一般衛生以外のboxの選択可能店舗マニュアル全てを取得する
    this.getSelectManual(this.typeAdd)
  },
  methods: {
    // オペレーション時拡大率変換
    setScale () {
      if (this.$refs.flowDiagram) {
        let val = (this.$refs.flowDiagram.clientWidth / this.$refs.flowDiagramTable.clientWidth) * 100
        val = Math.floor(val)
        val = val / 100
        this.flowDiagramScale = val
        this.otherExpansion = val * 0.7
      }
    },
    // 変数初期化
    initilize (flowDiagramId) {
      // パラメータ初期化
      this.manualIds = []
      this.classification = 0
      this.flowDiagramId = flowDiagramId
    },
    // 店舗マニュアルオープン処理
    // flowDiagramId:フローダイアグラムのID 0:一般衛生 -1:追加 それ以外の数値は作業ボックスID
    openManual (flowDiagramId, title) {
      // 計画策定から呼び出されるフローダイアグラムの場合、boxをクリックした際のモーダルは表示しない
      if (this.isPlan) return
      // パラメータ初期化
      this.initilize(flowDiagramId)

      // 割り当て済のデータを取得
      this.getAssignedManual(title)
    },
    // 割り当て済のデータを取得後のダイアログ表示処理
    showManualDialog () {
      // 参照モードでかつ、クリックされたboxに割り当て済のデータが存在しない場合は、処理終了とする
      if (this.isList && this.manuals.length === 0) return

      // 一般衛生をクリックされた場合は、名称を設定する。それ以外のboxの名称はgetAssignedManual()で設定している
      if (this.flowDiagramId === this.typeHygiene) this.flowDiagramName = this.$language.LabelGeneralHygiene

      // 店舗マニュアルダイアログを表示
      // 第1引数：表示するマニュアル情報
      // 第2引数：追加用マニュアル情報
      // 第3引数：クリックされたboxのID
      // 第4引数：変更前のマニュアル
      this.$refs.TemplateFlowDiagramManualDialog.showDialog(
        this.manuals,
        this.flowDiagramId === this.typeHygiene ? this.hygieneManagementSelectManuals : this.flowDaigramSelectManuals,
        this.flowDiagramId,
        this.oldManuals
      )
    },
    // 「店舗マニュアルを選択してください」のメッセージを設定する
    pushSelectMessage () {
      this.pushMessage(this.$language.MsgSelectedStoreManual)
    },
    // 「選択可能な店舗マニュアルがありません」のメッセージを設定する
    pushNoSelectMessage () {
      this.pushMessage(this.$language.MsgNoneSelectStoreManual)
    },
    // 「選択可能な店舗マニュアルがありません」のメッセージを設定する
    pushMessage (message) {
      if (this.flowDiagramId === this.typeAdd) {
        this.flowDaigramSelectManuals.push({
          label: message,
          value: 0
        })
      } else {
        this.hygieneManagementSelectManuals.push({
          label: message,
          value: 0
        })
      }
    },
    // 店舗マニュアルの保存ボタン押下(割り当て、解除)時の処理
    saveManuals (flowDiagramId, updateManualIds) {
      // 保存ボタンを押下した際のboxのid
      this.flowDiagramId = flowDiagramId
      // 更新対象の店舗マニュアルIdの配列
      let oldManualsIds = []
      // 一般衛生boxの保存処理の場合
      if (this.flowDiagramId === this.typeHygiene) {
        // DeleteInsertの考え方で保存処理を行う
        // 変更前のマニュアルを全て割り当て解除を行った後に、設定されている店舗マニュアルを一般衛生に変更する
        for (let cancelCount = 0; cancelCount < this.oldManuals.length; cancelCount++) {
          oldManualsIds.push(this.oldManuals[cancelCount].value)
        }
        this.updateManual(updateManualIds, oldManualsIds)
        // 更新を行った後は、完了画面を表示させる
        return
      }
      // フローダイアグラムのboxの店舗マニュアルの更新
      // 要素の行分ループ
      for (let trCount = 0; trCount < this.flowDiagramJsonData.length; trCount++) {
        // 要素の作業分ループ
        for (let tdCount = 0; tdCount < this.flowDiagramJsonData[trCount].diagramBoxes.length; tdCount++) {
          // 対象のbox以外は処理を飛ばす
          if (flowDiagramId !== this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].id) continue
          // 割り当てられていない場合はboxの色指定を削除する
          this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].tdStyle['background-color'] = updateManualIds.length === 0 ? '' : 'lemonchiffon'
          this.flowDiagramJsonData[trCount].diagramBoxes[tdCount]['manual'] = []
          this.flowDiagramJsonData[trCount].diagramBoxes[tdCount]['manual'] = updateManualIds
          // 数値でソート
          this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].manual.sort((a, b) => a - b)
          break
        }
      }
      // フローダイアグラムJsonデータ更新
      this.updateFrowDiagram()
    },
    // 保存完了後に確認ボタン押下された時の処理
    // フローダイアグラムで選択可能な店舗マニュアルを取得し、保持しておく(boxがクリックされる度に情報を取得しなくても良いように)
    close () {
      // 一般衛生以外のboxの選択可能店舗マニュアル全てを取得する
      this.getSelectManual(this.typeAdd)
      // 情報取得が完了してから親のコンポーネントのクリア等を行う
      this.$refs.TemplateFlowDiagramManualDialog.clear()
      this.$refs.TemplateFlowDiagramManualDialog.close()
    },
    // 押下されたbox内で既に割り当て済のデータを取得する
    getAssignedManual (title) {
      // 初期化
      this.manuals = []
      this.oldManuals = []
      // 検索条件を指定する
      switch (this.flowDiagramId) {
        // 一般衛生の場合
        case this.typeHygiene:
          this.classification = 3
          this.isAdd = false
          break
        // 一般衛生以外のbox内で既に割り当てられている店舗マニュアルのIDを取得
        default:
          this.classification = 1
          this.isAdd = false
          this.getAssignedManualsOfFlowDaigramBox()
          // 割り当て済のマニュアルが存在しない場合は、ここでダイアログ表示処理を行う⇒余計なAPI処理を行わないようにするため
          if (this.assignedManualIdsOfBox.length === 0) {
            this.showManualDialog()
            return
          }
          break
      }

      let data = {}
      // 検索条件の設定
      data.ids = this.assignedManualIdsOfBox
      data.classification = this.classification
      data.isAdd = this.isAdd

      let self = this

      // callBack関数を作成する
      function callbackAssigned (response) {
        // API成功時
        if (response.status === 200) {
          // 取得したデータが存在する場合
          if (response.data.length !== 0) {
            // 現在DBに設定されている表示用の店舗マニュアルを取得
            for (let i = 0; i < response.data.length; i++) {
              if (self.$props.isOperation) {
                self.manuals.push({
                  title: title,
                  label: response.data[i].name,
                  value: response.data[i].m_id,
                  m_id: response.data[i].m_id,
                  s_id: response.data[i].s_id,
                  workType: response.data[i].work_type,
                  period: response.data[i].period,
                  times: response.data[i].times
                })
              } else {
                self.manuals.push({
                  label: response.data[i].name,
                  value: response.data[i].m_id,
                  period: response.data[i].period,
                  times: response.data[i].times
                })
              }
            }
            // 変更前の店舗マニュアル情報を取得
            self.oldManuals = self.manuals
          }
          self.showManualDialog()
        // API失敗時
        } else {
          // 失敗
          self.errorMessage = self.$language.MsgFailedGet
          self.$refs.saveDialog.openDialog()
        }
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
      }

      // callBack関数を作成する
      function callbackError (err) {
        console.log(err)
        self.errorMessage = self.$language.MsgFailedGet
        self.$refs.saveDialog.openDialog()
      }
      data.callback = callbackAssigned
      data.errCallback = callbackError
      data.isOperation = this.$props.isOperation
      // 店舗マニュアル情報の取得
      // gogo
      this.$store.dispatch('systemConfig/actionSelectFlowDiagramManualData', data)
    },
    // 選択可能な店舗マニュアルを取得する
    getSelectManual (flowDiagramId) {
      this.flowDiagramId = flowDiagramId
      // 検索変数を初期化
      let data = {}

      // 店舗マニュアル取得データ格納
      data.ids = []
      data.classification = 1
      data.isAdd = true
      let self = this

      // コールバック関数を作成する
      function callbackSelectManual (response) {
        // API成功時
        if (response.status === 200 || self.$props.isOperation) {
          if (self.$props.isOperation) {
            response.data = response
          }
          // 取得したデータが存在する場合
          if (response.data.length !== 0) {
            // どこのboxの情報を取得するかで分岐を行う
            switch (self.flowDiagramId) {
              // 追加の場合⇒フローダイアグラム内のboxで選択可能な店舗マニュアルを設定
              case self.typeAdd:
                self.flowDaigramSelectManuals = []
                for (let i = 0; i < response.data.length; i++) {
                  // Loopの初回の時に、店舗マニュアルを選択してくださいという文言を設定する
                  if (i === 0) self.pushSelectMessage()
                  self.flowDaigramSelectManuals.push({
                    label: response.data[i].name,
                    value: response.data[i].m_id
                  })
                }
                // 一般衛生のbox内で設定可能な店舗マニュアルを取得する⇒クリックする度に毎回情報を取得してないようにする為
                self.getSelectManual(self.typeHygiene)
                break
              case self.typeHygiene:
                // 変数初期化
                self.hygieneManagementSelectManuals = []
                // 全作業boxに設定済の店舗マニュアルを取得する
                self.getAllSelectManualOfFlowDaigram()
                // 取得した全店舗マニュアルの中から、設定済の店舗マニュアルを除外する
                for (let i = 0; i < response.data.length; i++) {
                  // 設定済の店舗マニュアルのIDではない場合は追加する
                  if (self.allSelectedManuals.indexOf(response.data[i].id) === -1) {
                    // 一番最初はメッセージを設定する
                    if (self.hygieneManagementSelectManuals.length === 0) self.pushSelectMessage()
                    if (self.$props.isOperation) {
                      self.hygieneManagementSelectManuals.push({
                        label: response.data[i].name,
                        value: response.data[i].m_id,
                        m_id: response.data[i].m_id,
                        s_id: response.data[i].s_id
                      })
                    } else {
                      self.hygieneManagementSelectManuals.push({
                        label: response.data[i].name,
                        value: response.data[i].m_id
                      })
                    }
                  }
                }
                // 店舗マニュアルが設定されていない場合は、選択可能なマニュアルがない旨のメッセージを設定する
                if (self.hygieneManagementSelectManuals.length === 0) self.pushNoSelectMessage()
                break
              default:
                break
            }
          // 取得したデータが存在しない場合⇒割り当てられる店舗マニュアルが存在しない場合
          } else {
            // 選択可能な店舗マニュアルを初期化する
            switch (self.flowDiagramId) {
              case self.typeAdd:
                self.flowDaigramSelectManuals = []
                // 「選択可能な店舗マニュアルがありません」のメッセージを追加
                self.pushNoSelectMessage()
                // 一般衛生のbox内で設定可能な店舗マニュアルを取得する⇒クリックする度に毎回情報を取得してないようにする為
                self.getSelectManual(self.typeHygiene)
                return
              case self.typeHygiene:
                self.hygieneManagementSelectManuals = []
                // 「選択可能な店舗マニュアルがありません」のメッセージを追加
                self.pushNoSelectMessage()
                break
              default:
                break
            }
          }

          // 一般衛生情報再描画
          self.$emit('getGeneralHygieneManagement', true)
        // API失敗時
        } else {
          // 失敗
          self.errorMessage = self.$language.MsgFailedGet
          self.$refs.saveDialog.openDialog()
        }
        if (self.$props.isSetting) {
          self.accessCount++
          if (self.accessCount === 2) {
            // プログレスバーの非表示
            self.$store.dispatch('setIsLoading', false)
          }
        }
      }

      // callBack関数を作成する
      function callbackError (err) {
        console.log(err)
        self.errorMessage = self.$language.MsgFailedGet
        self.$refs.saveDialog.openDialog()
      }

      data.callback = callbackSelectManual
      data.errCallback = callbackError
      if (!this.$props.isOperation) {
        data.isOperation = this.$props.isOperation
        // 店舗マニュアル情報の取得
        this.$store.dispatch('systemConfig/actionSelectFlowDiagramManualData', data)
      }
    },
    // 全作業ボックスで割り当てられている店舗マニュアルIDを取得する
    getAllSelectManualOfFlowDaigram () {
      // 変数初期化
      this.allSelectedManuals = []
      // 要素の行分ループ
      for (let trCount = 0; trCount < this.flowDiagramJsonData.length; trCount++) {
        // 要素の作業分ループ
        for (let tdCount = 0; tdCount < this.flowDiagramJsonData[trCount].diagramBoxes.length; tdCount++) {
          // 1box内で割り当てられている店舗マニュアルを格納
          for (let manualCount = 0; manualCount < this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].manual.length; manualCount++) {
            // 各ボックスに設定されている店舗マニュアルIDを取得
            this.allSelectedManuals.push(this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].manual[manualCount])
          }
        }
        // 重複除去
        this.allSelectedManuals = this.allSelectedManuals.filter(function (x, i, self) { return self.indexOf(x) === i })
      }
    },
    // 一つのbox内に割り当て済の店舗マニュアルIDを取得する
    getAssignedManualsOfFlowDaigramBox () {
      this.assignedManualIdsOfBox = []
      // 要素の行分ループ
      for (let trCount = 0; trCount < this.flowDiagramJsonData.length; trCount++) {
        // 要素の作業分ループ
        for (let tdCount = 0; tdCount < this.flowDiagramJsonData[trCount].diagramBoxes.length; tdCount++) {
          // クリック選択されたboxのIDの場合、そこに割り当てられている店舗マニュアルのIDを取得する
          if (this.flowDiagramId === this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].id) {
            this.flowDiagramName = this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].title

            // ここのルートに来た場合は店舗マニュアルは割り当てられている為、割り当てられている店舗マニュアルを格納する
            for (let manualCount = 0; manualCount < this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].manual.length; manualCount++) {
              // 各ボックスに設定されている店舗マニュアルIDを取得
              this.assignedManualIdsOfBox.push(this.flowDiagramJsonData[trCount].diagramBoxes[tdCount].manual[manualCount])
            }
            // ここのルートまで来た場合は、ここで処理は終了する
            return
          }
        }
      }
    },
    // 店舗マニュアルの分類を更新する
    updateManual (updateManualIds, oldManualsIds) {
      let data = {}
      // 更新データ格納
      data.updateManualIds = updateManualIds
      data.oldManualsIds = oldManualsIds
      let self = this

      // コールバック関数を作成する
      function callbackUpdateManual (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        // 失敗時
        if (response.status !== 200) self.errorMessage = self.$language.MsgFailedEdit
        // 完了ダイアログを表示する
        self.$refs.saveDialog.openDialog()
      }

      // callBack関数を作成する
      function callbackError (err) {
        console.log(err)
        self.errorMessage = self.$language.MsgFailedEdit
        self.$refs.saveDialog.openDialog()
      }

      data.callback = callbackUpdateManual
      data.errCallback = callbackError

      // 店舗マニュアル情報更新
      this.$store.dispatch('systemConfig/actionUpdateFlowDiagramManualData', data)
    },
    // フローダイアグラム更新処理
    updateFrowDiagram () {
      let data = {}
      // 更新するJsonデータ格納
      data.json = JSON.stringify(this.flowDiagramJsonData)
      data.id = this.id
      let self = this

      // コールバック関数を作成する
      function callbackUpdateFrowDiagram (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        // 失敗時
        if (response.status !== 200) self.errorMessage = self.$language.MsgFailedEdit
        // 完了ダイアログを表示する
        self.$refs.saveDialog.openDialog()
      }

      // callBack関数を作成する
      function callbackError (err) {
        console.log(err)
        self.errorMessage = self.$language.MsgFailedEdit
        self.$refs.saveDialog.openDialog()
      }

      data.callback = callbackUpdateFrowDiagram
      data.errCallback = callbackError

      // 雛形のフローダイアグラムデータを編集
      this.$store.dispatch('systemConfig/actionUpdateFlowDiagramData', data)
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/systemConfig/flowDiagram.scss';
</style>
